import { render, staticRenderFns } from "./SocialFeedComments.vue?vue&type=template&id=690fcf7e&"
import script from "./SocialFeedComments.vue?vue&type=script&lang=js&"
export * from "./SocialFeedComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports